<script lang="ts" setup>
    import { useUserStore } from '@/stores/user';
    import { useDisplay, useTheme } from 'vuetify';
    import { useNumberFormatter } from '@/composables/useNumberFormatter';

    const userStore = useUserStore();
    const theme = useTheme();
    const display = useDisplay();
    const { t } = useI18n();
    const { formatNumber } = useNumberFormatter();

    const desktopWidth = computed<number>(() => {
        let width = 1425;
        if (!userStore.settings.is_show_exposure) width -= 130;
        if (!userStore.settings.is_show_balance) width -= 130;
        if (!userStore.settings.is_show_credit) width -= 115;
        return width;
    });

    onMounted((): void => {
        console.log('Component app-menuUserBalanceInfo mounted.');
    });
</script>
<template>
    <div v-if="userStore.isLoggedIn()" class="menu-user-balance">
        <div v-if="userStore.settings.is_show_exposure" class="float-right user-balance px-2 my-3">
            {{ t('menu.exposure') }}
            <br :class="[display.width.value < desktopWidth ? 'd-none d-sm-flex d-md-flex d-lg-flex d-xl-none' : '', 'd-flex d-sm-none']" />
            <span :class="[display.xs.value ? 'lh-1-1' : '', 'orangeText', 'bold']">{{ userStore.currency.symbol }}{{ formatNumber(userStore.balance.exposure, 'money') }}</span>
        </div>
        <div v-if="userStore.settings.is_show_balance" class="px-2 float-right user-balance my-3">
            {{ t('menu.balance') }}
            <br :class="[display.width.value < desktopWidth ? 'd-none d-sm-flex d-md-flex d-lg-flex d-xl-none' : '', 'd-flex d-sm-none']" />
            <span :class="[display.xs.value ? 'lh-1-1' : 'pl-1', userStore.balance.balance < 0 ? 'redText' : 'greenText', '', 'bold']">
                {{ userStore.currency.symbol }}{{ formatNumber(userStore.balance.balance, 'money') }}
            </span>
        </div>
        <div v-if="userStore.settings.is_show_credit" :class="[display.width.value < 524 ? 'pl-0 pr-2' : 'px-2', 'float-right user-balance my-3']">
            {{ t('menu.credit') }}
            <br :class="[display.width.value < desktopWidth ? 'd-none d-sm-flex d-md-flex d-lg-flex d-xl-none' : '', 'd-flex d-sm-none']" />
            <span :class="[display.xs.value ? 'lh-1-1' : '', theme.name.value === 'dark' ? 'text-white' : 'text-black', 'bold']">
                {{ userStore.currency.symbol }}{{ formatNumber(userStore.balance.credit, 'money') }}
            </span>
        </div>
    </div>
</template>
<style scoped>
    .v-theme--light .user-balance {
        color: grey;
    }

    .v-theme--dark .user-balance {
        color: #a7aab4;
    }

    .menu-user-balance {
        font-size: 14px;
    }

    @media (min-width: 370px) and (max-width: 750px) {
        .menu-user-balance {
            font-size: 12px;
        }
    }

    @media (max-width: 369px) {
        .menu-user-balance {
            font-size: 10px;
        }
    }
</style>
